import { useState, useEffect } from 'react';
import { getCountryFromGeoData } from '../components/ShippingForm/shippingform.utils';

interface UserLocation {
  lat: number;
  long: number;
  country?: {
    long_name: string;
    short_name: string;
  };
}

export const useGeoLocation = () => {
  const [location, setLocation] = useState<UserLocation | null>(null);
  useEffect(() => {
    const getLocationData = async () => {
      if (location?.lat && location.long) {
        const locationResponse =
          await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${location?.lat},${location?.long}&key=${process.env.REACT_APP_GOOGLE_API_KEY}
`);
        const locationData = await locationResponse.json();
        if (locationData?.results) {
          const countryData = getCountryFromGeoData(locationData?.results);
          if (countryData?.long_name && countryData?.short_name) {
            setLocation({
              lat: location?.lat,
              long: location?.long,
              country: {
                long_name: countryData?.long_name,
                short_name: countryData?.short_name,
              },
            });
          }
        }
      }
    };
    getLocationData();
  }, [location?.lat, location?.long]);

  useEffect(() => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            lat: position.coords.latitude,
            long: position.coords.longitude,
          });
        },
        (error) => {
          // eslint-disable-next-line no-console
          console.error(
            'Location error',
            `Error Code = ${error.code} - ${error.message}`
          );
        }
      );
    } else {
      // eslint-disable-next-line no-console
      console.info('Your browser does not support geolocation');
    }
  }, []);
  return location;
};
